<template>
  <div class="base-tabs">
    <div class="base-tabs__nav">
      <button
        v-for="tab in tabs"
        :key="tab.name"
        :class="{ 'is-active': tab.name === value }"
        @click="selectTab(tab.name)"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- 內容 -->
    <div class="base-tabs__content">
      <slot :tabs="tabs"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTabs',
  props: {
    /**
     * 當前造訪的頁籤名稱(雙向綁定)
     */
    value: {
      type: String,
      required: true,
    },
    /**
     * 頁籤列表
     */
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     * 選取頁籤
     * @param {String} name 頁籤名稱
     */
    selectTab(name) {
      this.$emit('input', name);
    },
  },
};
</script>

<style lang="sass" scoped>
.base-tabs
  &__nav
    display: flex
    align-items: center
    justify-content: center
    padding-top: 4px
    padding-bottom: 4px
    gap: 0px 24px

  button
    position: relative
    border: 0
    outline: 0
    color: #C6C6C6
    font-size: 0.875rem
    font-weight: 600
    line-height: 20px
    padding: 0 0 4px 0
    background-color: transparent
    cursor: pointer

    &::after
      content: ''
      position: absolute
      bottom: 0
      left: 0
      width: 100%
      height: 4px
      border-top-left-radius: 4px
      border-top-right-radius: 4px
      background-color: transparent
      transition: background-color 0.25s

    &.is-active
      color: #333333

      &::after
        background-color: #FFEA00
</style>
